// extracted by mini-css-extract-plugin
module.exports = {"container":"_19J96Q8pxM5dwAd3P_xovU"};